import * as _ from "lodash";
import * as Backbone from "backbone";
import {BrandCollection} from "../collections/Brands";
import {InstallCollection} from "../collections/Installs";
import {PermissionCollection} from "../collections/Permissions";
import {OrganizationCollection} from "../collections/Organizations";
import {DashboardCollection} from "../collections/Dashboards";
import {DashboardChannelCollection} from "../collections/DashboardChannels";
import {User} from "../models/User";
import {AppRegistry} from "../apps/AppRegistry";
import {AppCollection} from "../collections/Apps";


export class BaseView extends Backbone.View<Backbone.Model> {

    options: Backbone.ViewOptions<Backbone.Model>;

    constructor(options: Backbone.ViewOptions<Backbone.Model>) {
        super(options);

        this.options = <Backbone.ViewOptions<Backbone.Model>> _.omit(options, <any>[
            'model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events']);
    };

    remove() : this {
        this.stopListening();
        return super.remove();
    }

    reloadUrl() {
        Backbone.history.loadUrl();
    }
}

export interface BaseBrandedViewOptions extends Backbone.ViewOptions<Backbone.Model> {
    brandCollection: BrandCollection
}
export class BaseBrandedView extends BaseView {

    options: BaseBrandedViewOptions;

    constructor(options: BaseBrandedViewOptions) {
        super(options);
    };
}


export interface BaseInternalViewOptions extends BaseBrandedViewOptions {
    appRegistry: AppRegistry;
    appCollection: AppCollection;
    installCollection: InstallCollection;
    permissionCollection: PermissionCollection
    organizationCollection: OrganizationCollection;
    dashboardCollection: DashboardCollection;
    dashboardChannelCollection: DashboardChannelCollection;
    currentUser: User
}

export class BaseInternalView extends BaseBrandedView {

    options: BaseInternalViewOptions;

    constructor(options: BaseInternalViewOptions) {
        super(options);
    };
}

// BaseController is just an alias for Backbone View but it has a different name to show it's not
// connected to UI elements
export class BaseController extends BaseView {}



// WEBPACK FOOTER //
// ./srv/public/js/views/_BaseViews.ts